import { Model } from "pinia-orm";

export default class PreparationWithAnalysis extends Model {
  static entity = "preparationsWithAnalysis";
  static primaryKey = "uuid";

  static fields() {
    return {
      uuid: this.uid(""),
      project: this.attr(null),
      materials: this.attr([]),
      validatedMaterials: this.attr([]),
      isValidated: this.boolean(false),
      analysis: this.attr([]),
      totalAnalysis: this.attr(null),
      totalAnalysisCost: this.attr(null),
    };
  }
}
